import { render, staticRenderFns } from "./SubEmpresaPreencherContrato.vue?vue&type=template&id=5b8d15f5&lang=pug"
import script from "./SubEmpresaPreencherContrato.vue?vue&type=script&lang=js"
export * from "./SubEmpresaPreencherContrato.vue?vue&type=script&lang=js"
import style0 from "./SubEmpresaPreencherContrato.vue?vue&type=style&index=0&id=5b8d15f5&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports